import { CONTACT_US_SECTION_BY_KEY, CONTACT_US_SECTIONS } from "@/content/data";
import type { ContactUsSection, Key, KeyList } from "@/content/types";

type GetContactUsSectionOptions = {
  limit?: number;
};

export function getContactUsSections(
  keys?: KeyList,
  options?: GetContactUsSectionOptions,
): ContactUsSection[] {
  if (!keys) {
    return CONTACT_US_SECTIONS.slice(0, options?.limit);
  }

  const list = Array.isArray(keys) ? keys : [keys];

  return list
    .map(key => CONTACT_US_SECTION_BY_KEY[key])
    .filter(Boolean)
    .slice(0, options?.limit);
}

export function getContactUsSection(key: Key): ContactUsSection {
  return CONTACT_US_SECTION_BY_KEY[key];
}
